<template>
  <div class="page-width">
    <div class="sign-container">
      <div class="mobile-signin-header">
        <h2 class="mobile-registered">Create <span class="first-word">New Customer</span> Account</h2>
        <p class="mobile-signin-note">Creating an account has many benefits: faster checkout, save more than one address, track orders and more.</p>
      </div>
      <el-form v-if="!registered && !registering" class="register-container" @keyup.enter.native="register(registerForm)" :model="registerForm">
        <p v-if="errors.length" style='padding-bottom: 20px; width: 90%'>
          <b>{{ $t('followingErrors') }}</b>
          <ul style="color: red">
            <li v-for="error in errors">{{ error }}</li>
          </ul>
        </p>
        <div class="name-container">
          <el-input class="register-modal-first" placeholder="First Name" v-model="registerForm.FirstName" ></el-input>
          <el-input class="register-modal-last" placeholder="Last Name" v-model="registerForm.LastName" ></el-input>
        </div>
        <el-input class="register-modal-input" placeholder="Email Address" v-model="registerForm.username" ></el-input>
        <el-input class="register-modal-input" placeholder="Password" v-model="registerForm.password" type="password" >
        </el-input>
        <div class="password-input">
          <el-input class="register-modal-input" placeholder="Confirm Password" v-model="registerForm.confirmPassword" type="password"></el-input>
        </div>
        <el-button class="register-button" type="submit" @click="register(registerForm)">
          Create an Account
        </el-button>
      </el-form>
      <el-form v-if="registering && !registered" >
        <loading />
      </el-form>
    </div>
  </div>
</template>
​
​<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import { isUserAuthenticated } from '../../store/modules/cart';
import loading from '../loading';
export default {
  name: 'confirmation',
  components: {
    loading
  },
  data() {
    return {
      errors: [],
      registerForm: {
        FirstName: '',
        LastName: '',
        email: '',
        password:'',
        username: '',
        confirmPassword: '',
      },
      b2bFirstName: '',
      b2bLastName: '',
      email:'',
      login: true, // true showlogin; false forget password
      showModal: false,
      validPasswords: false,
    }
  },
  methods: {
    ...mapActions('auth', ['mobileLoginRequest', 'checkUsername', 'resetEmail', 'sentVerificationCode', 'resetPassword', 'registerBusinessCustomer', 'checkEmail', 'registerRequest']),
    ...mapMutations('auth', ['userRegistered', 'registeringUser', 'registerError']),
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    register: async function(form) {
      form.email = this.registerForm.username;
      await this.checkForm(form);
      if(!this.errors.length) {
        this.registeringUser();
        this.registerRequest(form)
        .then(res => {
          this.userRegistered();
          this.mobileLoginRequest({username: form.username, password: form.password});
        })
        .catch( err => {
          console.log("err:", err);
          this.registerError();
          this.errors = [];
          this.errors.push(this.$t('errorCreateAccount'));
        })
      }
    },
    checkForm: async function (form) {
      this.errors = [];
      const usernameBeenTaken = await this.checkUsername({ username: form.username });
      if (!form.FirstName) {
        this.errors.push(this.$t('firstNameRequired'))
      };
      if (!form.LastName) {
        this.errors.push(this.$t('lastNameRequired'))
      };
      if (form.password.length < 8) {
        this.errors.push(this.$t('passwordLengthRequired'))
      }
      if (form.username.length < 5) {
        this.errors.push(this.$t('usernameLengthRequired'));
      }
      if (usernameBeenTaken.data.isTaken) {
        this.errors.push(this.$t('usernameTaken'))
      }
      if (!this.validPasswords) {
        this.errors.push('Your passwords do not match.')
      }
      if (!form.username) {
        this.errors.push(this.$t('emailRequired'));
      } else if (!this.validEmail(form.username)) {
        this.errors.push(this.$t('emailValidRequired'));
      } else {
        const res = await this.checkEmail({ email: form.username })
        if (res.data.isTaken) {
          this.errors.push(this.$t('emailIsTaken'))
        }
      } 
    },
    verifyPasswords() {
      if (this.registerForm.password === this.registerForm.confirmPassword) {
        this.validPasswords = true;
      } else {
        this.validPasswords = false;
      }
    },
  },
  computed: mapState({
    businessRegistrationLoading: state => state.auth.businessRegistrationLoading, // not used
    businessRegistrationSuccessful: state => state.auth.businessRegistrationSuccessful, // not used
    registering: state => state.auth.registering,
    registered: state => state.auth.registered,
  }),
  watch: {
    'registerForm.password': function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.verifyPasswords();
      }
    },
    'registerForm.confirmPassword': function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.verifyPasswords();
      }
    }
  }
}
</script>
​
<style scoped lang="less">
@import "../../assets/css/signUpModal.less";
</style>



// WEBPACK FOOTER //
// src/view/Auth/register.vue